var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { axiosPrivate } from "../../../../../api/axios";
import { LogLevel } from "../../../../../Shared/hooks/useLogging/Logging-types";
import { PaymentMethodType } from "../../types/PaymentProcessorTypes";
export const getGiftCardByNumber = (datadogLog) => (giftCardNumber) => __awaiter(void 0, void 0, void 0, function* () {
    return yield axiosPrivate
        .get(`/GetPaymentMethods?type=${PaymentMethodType.GIFTCARD}&giftCardNumber=${giftCardNumber}`)
        .then(({ data }) => {
        if (data.success === false) {
            datadogLog(`Failed to load gift card: ${giftCardNumber}`, LogLevel.ERROR, {});
            return;
        }
        if (!data.giftCards || data.giftCards.length == 0)
            return undefined;
        return {
            id: data.giftCards[0].id,
            type: data.giftCards[0].type,
            giftCardNumber: data.giftCards[0].giftCard.giftCardNumber,
            balance: data.giftCards[0].giftCard.balance,
            initialValue: data.giftCards[0].giftCard.initialValue,
        };
    })
        .catch((err) => {
        var _a;
        console.error(err);
        const errorMessage = (_a = err.message) !== null && _a !== void 0 ? _a : `Failed to load gift card: ${giftCardNumber}`;
        datadogLog(errorMessage, LogLevel.ERROR, {}, err);
        return;
    });
});
